// extracted by mini-css-extract-plugin
export default {"toolbar":"BuildingsTab_toolbar__3HY9P","table":"BuildingsTab_table__SUSBu","smallBtn":"BuildingsTab_smallBtn__IkNO0"};